import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiExecutionSettingsComponent } from '@components/ui-execution-settings/ui-execution-settings.component';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { TranslateModule } from '@ngx-translate/core';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        ComponentSharedModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UiSuggestModule,
        TranslateModule,
        UiToggleSwitchModule,
        MatSlideToggleModule,
        MatInputModule,
        MatProgressSpinnerModule,
        UiNgLetModule,
    ],
    declarations: [
        UiExecutionSettingsComponent,
    ],
    exports: [
        UiExecutionSettingsComponent,
    ],
})
export class UiExecutionSettingsModule { }
